<template>
  <section id="section2">
    <div class="wrapper">
      <div class="row">
        <div class="column">
          <video controls width="100%">
            <source :src="videoUrl" type="video/mp4">
          </video>
        </div>
        <div class="column">
          <h3>{{ content['1.kop1'] }}</h3>
          <p>{{ content['1.uitleg1'] }}</p>
        </div>
      </div>
      <div class="row feature">
        <div class="eight columns">
          <h3>{{ content['1.kop2'] }}</h3>
          <p>{{ content['1.uitleg2'] }}</p>
        </div>
        <div class="four columns">
          <img src="../../assets/images/sponsors/logo_apc.png" />
        </div>
      </div>
      <div>
        <Arrow-Button direction="down" v-scroll-to="'#section3'" />
      </div>
    </div>
  </section>
</template>

<script>
import content from '@/content/website.json'
import ArrowButton from '@/components/home/ArrowButton.vue'

export default {
  name: 'Section2',
  components: {
    ArrowButton
  },
  data () {
    return {
      content: content,
      videoUrl: 'https://static.eo.nl/eo/heldengame/video/heldengame.mp4'
    }
  }
}
</script>

<style scoped lang="scss">
#section2 {
  position: relative;
  padding: 6rem 9rem;
  margin-bottom: 15rem;
  background-color: $color-green;
  background-image: url("~@/assets/images/groeneswoosh.png");
  background-repeat: no-repeat;
  background-size: 80%;

  .column {
    margin-bottom: 3rem;
  }

  h2, h3 {
    color: $color-white;
  }
}

.wrapper {
  max-width: 99.2rem;
  margin: 0 auto;

> div:last-child {
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translate(-50%, 9rem);
  }
}

.feature {
  position: relative;
  padding: 6rem;
  margin-bottom: -15rem;
  background-color: $color-yellow;
  clip-path: polygon(
    0 0, /* left top */
    100% 0, /* right top */
    95% 100%, /* right bottom */
    0 90% /* left bottom */
  );
}
</style>
